import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = React.useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = loc.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        // Persist token in localStorage too so legacy Bearer flow works.
        if (data.session_token) localStorage.setItem("bizzatlas_token", data.session_token);
        await refresh();
        toast.success(`Welcome, ${data.user.name}`);
        nav("/dashboard", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-[70vh] grid place-items-center" data-testid="auth-callback-page">
      <div className="text-center">
        <Loader2 className="h-8 w-8 text-zinc-900 animate-spin mx-auto" />
        <div className="mt-4 font-display text-xl">Finishing sign-in…</div>
      </div>
    </div>
  );
}
